const config = {
  name: "port-seattle",
  features: {
    accessCodes: false,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: false, // Display "Redemptions left" on promo code card
    mandatoryFields: false,
    userPhoneNumber: true,
    userName: true,
    showAdaSupport: false,
    userPostalCode: false
  },
  parkingSession: {
    // Until 7:00 AM, 7 days before the start
    cancelDaysBefore: 7,
    cancelTime: "07:00",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 8 am
    startOffsetHrs: 7,
    // Start date offset from today (0 = today)
    startOffsetDate: 0,
    // End date offset from start time
    endOffsetDate: 300
  }
}
export default config
